import { render, staticRenderFns } from "./DownlineRepBusinessInfo.vue?vue&type=template&id=1a9f347a&"
import script from "./DownlineRepBusinessInfo.vue?vue&type=script&lang=js&"
export * from "./DownlineRepBusinessInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports